// import React, { useEffect, useState } from 'react';
// import { Button, Loading } from '@alifd/next';
// import moment from 'moment';
// import { useHistory } from 'react-router-dom';
// import utils from '@/common/utils';
// import styles from './index.module.scss';
// import { PrivateService, DingzhiService } from '@/service';
// import LzMsg from '@/components/common/LzMsg';
// import BaseCheck from './components/BaseInfo/index';
// import SMSInfoForm from './components/PushInvitate/index';
// import NewVipNotPhase from './components/PeopleSelect/NewVipNotPhase/index';
// import ActiveClient from './components/PeopleSelect/ActiveClient/index';
// import FirstPurchaseCrowd from './components/PeopleSelect/FirstPurchaseCrowd/index';
// import PullNewMemberComponent from './components/PeopleSelect/PullNewMember/index';
// import LoveGoodsComponent from './components/PeopleSelect/LoveGoods/index';
// import SecondCheckDialog from '@/components/SecondCheckDialog/SecondCheckDialogAuto';
// import LzDialog from '@/components/common/LzDialog';

// import BirthayPresentComponent from './components/PeopleSelect/BirthayPresent/index';
// import YearPresentComponent from './components/PeopleSelect/YearPresent/index';
// import RepurchaseReminderComponent from './components/PeopleSelect/RepurchaseReminder/index';
// import SleepAwakenComponent from './components/PeopleSelect/SleepAwaken/index';
// import HundredthDayComponent from './components/PeopleSelect/HundredthDay/index';
// import InterestedCustomersComponent from './components/PeopleSelect/InterestedCustomers/index';
// import PurchasedNotOpenedComponent from './components/PeopleSelect/PurchasedNotOpened/index';
// import MembersDayComponent from './components/PeopleSelect/MembersDay/index';
// import HighValueUserPurchaseConversionComponent from './components/PeopleSelect/HighValueUserPurchaseConversion/index';
// import ValueCardComponent from './components/PeopleSelect/ValueCard/index';
// import PlusMemberComponent from './components/PeopleSelect/PlusMember/index';
// import MemberPointComponent from './components/PeopleSelect/MemberPoint/index';
// import LiveInterestingComponent from './components/PeopleSelect/LiveInteresting/index';
// import useGetPoList from '@/hooks/public/useGetPoList';
// import Cookie from 'js-cookie';

// import CONSTANTS from '@/utils/constant';

// const NewMisionCreate = (props) => {
//   const { poList, showPoList } = useGetPoList(); // po列表, 是否展示po列表
//   const history = useHistory();
//   // 页面loading
//   const [pageLoading, setPageLoading] = useState(true);
//   // 能否修改投放时间
//   const [canChangeTime, setCanChangeTime] = useState(true);
//   // 新建1 复制2 查看3
//   const [checkType, setCheckType] = useState(1);
//   // 权益配置数据
//   const [tempTplData, setTempTplData] = useState([]);
//   // 人群过滤条件里对于checkbox是否勾选的标识
//   const baseFilterConditionCheckboxs = {
//     filterAlreadySendTip: false,
//     filterOrderCountTip: false,
//     filterMaxMemberCountTip: false,
//     filterLastOrderTimeTip: false,
//     filterCrowdTip: false,
//   }
//   // 麻烦这些备注参考短信营销任务创建
//   const [filterConditionCheckboxs, setFilterConditionCheckboxs] = useState({
//     ...baseFilterConditionCheckboxs
//   });
//   const [filterMaxMemberCountReal, setFilterMaxMemberCountReal] = useState(1);
//   // 创建参数
//   const [creatParams, setCreatParams] = useState({
//     viewButton: {
//       modelId: 4,
//       firstHalf: [
//         {
//           select: true,
//           crowdDesc: '新增会员，并从未在店铺购买过的用户',
//           crowdName: '新会员开卡未购人群',
//           crowdSubId: 1,
//         },
//         {
//           select: false,
//           crowdDesc: '新增会员，开卡后至今未在店铺购买过的用户',
//           crowdName: '新会员开卡未购人群',
//           crowdSubId: 2,
//         },
//       ],
//       secondHalf: {
//         addParam: {
//           custom: null,
//           normal: [1],
//         },
//         subShopId: null,
//       },
//     },
//     campaignEndTime: '',
//     // "campaignModel": "模型名称",
//     // "campaignModelId": 2134533121214,
//     campaignName: '',
//     campaignRemark: '',
//     campaignStartTime: '',
//     // "crowdDelayTime": 7200000,
//     crowdDelayTime: 50400000,
//     frequencyValue: 1,
//     lauchDelayTime: '',
//     smsContent: '',
//     smsLongUrl: '',
//     smsPoNum: '',
//     smsShortUrl: '',
//     smsSign: '',
//     frequencyType:1, //频率类型（1:天，2:周，3:月 4:特殊形式,利用crontab组成复杂的时间结构）
//     filterBlackList: false,
//     addWhiteList: false,
//     filterAlreadySend: 0,
//     filterOrderCount : 0,
//     filterMaxMemberCount : 0,
//     filterMaxMemberCountShow : 0,
//     filterLastOrderTime: 0, // 是否过滤最近一次下单时间（同上）
//     filterCrowdId: '', // 是否过滤人群id（同上）
//     filterCrowdName: '',
//     crontab:{
//       second:{
//           every:false,
//           ofUpLevel:[]              //sencondOfMinute
//       },
//       minute:{
//           every:false,
//           ofUpLevel:[]              //minuteOfHour
//       },
//       hour:{
//           every:false,
//           ofUpLevel:[]              //hourOfDay
//       },
//       day:{
//           every:false,
//           ofUpLevel:[]              //dayOfMonth     如每月的第5和第10日 就是 every:false,ofUpLevel:[5,10];   如每2天执行一次 就是 every:true,ofUpLevel:[2]
//       },
//       month:{
//           every:false,
//           ofUpLevel:[]              //monthOfYear
//       },
//       dayOfWeek:{
//           every:false,
//           ofUpLevel:[]              //dayOfWeek
//       }
//   }
//   });

//   // 预估人数
//   const [forNum, setForNum] = useState(0);
//   // 是否需要品牌筛选和po选择
//   // const [isBaojie, setIsBaojie] = useState(false)
//   // 品牌列表
//   const [brand, setBrand] = useState([]);

//   const [timevalue, setTimevalue] = useState([]);

//   // 请求回来的po列表
//   // const [polist, setPolist] = useState([])

//   // 复制时进页面传来的结束时间
//   const [tempEndTime, setTempEndTime] = useState(0);
//   // 点击复制时的长链和短链
//   const [linkList, setLinkList] = useState({
//     long: '',
//     short: '',
//   });
//   // 二次确认弹窗
//   const [secondCheckDialog, setSecondCheckDialog] = useState(false);
//   // 二次确认弹窗中的data
//   const [secondData, setSecondData] = useState({});
//   // 获取店铺手机号
//   const getPhoneList = () => {
//     DingzhiService.getSignphone()
//       .then((resTest: any) => {
//         setphoneList(resTest.data);
//       })
//       .catch((e) => console.log(e));
//   };

//   /**
//    * 渲染基础信息模块
//    */
//   const showBaseInfo = () => {
//     const BaseInfo = BaseCheck.components.Form;
//     return (
//       <BaseInfo
//         params={creatParams}
//         desc={
//           props.location.state
//             ? props.location.state.checkType===1
//                 ? props.location.state.data.activityDescription
//                 :props.location.state.data.formData.activityDescription
//                   ?props.location.state.data.formData.activityDescription:''
//             : ''
//         }
//         timevalue={timevalue}
//         poList={poList}
//         setTimevalue={(v) => {
//           setTimevalue(v);
//         }}
//         setBaseInfo={(v) => {
//           setCreatParams(v);
//         }}
//         checkType={checkType}
//         canChangeTime={canChangeTime}
//         isbaojie={showPoList}
//       />
//     );
//   };
//   /**
//    * 校验基础信息模块是否全部填写
//    */
//   const checkBaseInfoContent = async () => {
//     return Promise.all(
//       Object.keys(BaseCheck.data())
//         .filter((key) => key in BaseCheck.validators)
//         .map((key) => BaseCheck.validators[key](creatParams))
//     );
//   };

//   /**
//    * 开卡未购人群
//    */
//   const showCrowdInfo = () => {
//     const CrowdInfo = NewVipNotPhase.components.Form;
//     return (
//       <CrowdInfo
//         params={creatParams}
//         timevalue={timevalue}
//         poList={poList}
//         setTimevalue={(v) => {
//           setTimevalue(v);
//         }}
//         setCreatParams={(v) => {
//           setCreatParams(v);
//         }}
//         checkType={checkType}
//         canChangeTime={canChangeTime}
//         isbaojie={showPoList}
//         setNum={(v) => {
//           setForNum(v);
//         }}
//       />
//     );
//   };
//   /**
//    * 活跃用户人群
//    */
//   const activeCrowd = () => {
//     const ActiveCrowd = ActiveClient.components.Form;
//     return (
//       <ActiveCrowd
//         params={creatParams}
//         timevalue={timevalue}
//         poList={poList}
//         setTimevalue={(v) => {
//           setTimevalue(v);
//         }}
//         setCreatParams={(v) => {
//           setCreatParams(v);
//         }}
//         checkType={checkType}
//         canChangeTime={canChangeTime}
//         isbaojie={showPoList}
//         setNum={(v) => {
//           setForNum(v);
//         }}
//       />
//     );
//   };
//   /**
//    * 首购人群
//    */
//   const firstPurchaseCrowd = () => {
//     const FirstCrowd = FirstPurchaseCrowd.components.Form;
//     return (
//       <FirstCrowd
//         params={creatParams}
//         timevalue={timevalue}
//         poList={poList}
//         setTimevalue={(v) => {
//           setTimevalue(v);
//         }}
//         setCreatParams={(v) => {
//           setCreatParams(v);
//         }}
//         checkType={checkType}
//         canChangeTime={canChangeTime}
//         isbaojie={showPoList}
//         setNum={(v) => {
//           setForNum(v);
//         }}
//       />
//     );
//   };
//   /**
//    * 热爱好物
//    */
//   const LoveGoods = () => {
//     const LovaGoodsCrowd = LoveGoodsComponent.components.Form;
//     return (
//       <LovaGoodsCrowd
//         params={creatParams}
//         timevalue={timevalue}
//         poList={poList}
//         setTimevalue={(v) => {
//           setTimevalue(v);
//         }}
//         setCreatParams={(v) => {
//           setCreatParams(v);
//         }}
//         checkType={checkType}
//         canChangeTime={canChangeTime}
//         isbaojie={showPoList}
//         setNum={(v) => {
//           setForNum(v);
//         }}
//       />
//     );
//   };
//   /**
//    * 会员拉新
//    */
//   const PullNewMember = () => {
//     const PullNewMemberCrowd = PullNewMemberComponent.components.Form;
//     return (
//       <PullNewMemberCrowd
//         params={creatParams}
//         timevalue={timevalue}
//         poList={poList}
//         setTimevalue={(v) => {
//           setTimevalue(v);
//         }}
//         setCreatParams={(v) => {
//           setCreatParams(v);
//         }}
//         checkType={checkType}
//         canChangeTime={canChangeTime}
//         isbaojie={showPoList}
//         setNum={(v) => {
//           setForNum(v);
//         }}
//       />
//     );
//   };
//   /**
//    *  生日礼
//    */
//   const BirthayPresent = () => {
//     const BirthayPresent = BirthayPresentComponent.components.Form;
//     return (
//       <BirthayPresent
//         params={creatParams}
//         timevalue={timevalue}
//         poList={poList}
//         setTimevalue={(v) => {
//           setTimevalue(v);
//         }}
//         setCreatParams={(v) => {
//           setCreatParams(v);
//         }}
//         checkType={checkType}
//         canChangeTime={canChangeTime}
//         isbaojie={showPoList}
//         setNum={(v) => {
//           setForNum(v);
//         }}
//       />
//     );
//   };
//   /**
//    *  周年礼
//    */
//   const YearPresent = () => {
//     const YearPresent = YearPresentComponent.components.Form;
//     return (
//       <YearPresent
//         params={creatParams}
//         timevalue={timevalue}
//         poList={poList}
//         setTimevalue={(v) => {
//           setTimevalue(v);
//         }}
//         setCreatParams={(v) => {
//           setCreatParams(v);
//         }}
//         checkType={checkType}
//         canChangeTime={canChangeTime}
//         isbaojie={showPoList}
//         setNum={(v) => {
//           setForNum(v);
//         }}
//       />
//     );
//   };
//   /**
//    * 复购提醒
//    */
//   const RepurchaseReminder = () => {
//     const RepurchaseReminder = RepurchaseReminderComponent.components.Form;
//     return (
//       <RepurchaseReminder
//         params={creatParams}
//         timevalue={timevalue}
//         poList={poList}
//         setTimevalue={(v) => {
//           setTimevalue(v);
//         }}
//         setCreateParams={(v) => {
//           setCreatParams(v);
//         }}
//         checkType={checkType}
//         canChangeTime={canChangeTime}
//         isbaojie={showPoList}
//         setNum={(v) => {
//           setForNum(v);
//         }}
//       />
//     )
//   }
//   /**
//    *  沉默用户唤醒
//    */
//   const SleepAwaken = () => {
//     const SleepAwaken = SleepAwakenComponent.components.Form;
//     return (
//       <SleepAwaken
//         params={creatParams}
//         timevalue={timevalue}
//         poList={poList}
//         setTimevalue={(v) => {
//           setTimevalue(v);
//         }}
//         setCreatParams={(v) => {
//           setCreatParams(v);
//         }}
//         checkType={checkType}
//         canChangeTime={canChangeTime}
//         isbaojie={showPoList}
//         setNum={(v) => {
//           setForNum(v);
//         }}
//       />
//     );
//   };
//   /**
//    * 百日礼
//    */
//   const HundredthDay = () => {
//     const HundredthDay = HundredthDayComponent.components.Form;
//     return (
//       <HundredthDay
//         params={creatParams}
//         timevalue={timevalue}
//         poList={poList}
//         setTimevalue={(v) => {
//           setTimevalue(v);
//         }}
//         setCreatParams={(v) => {
//           setCreatParams(v);
//         }}
//         checkType={checkType}
//         canChangeTime={canChangeTime}
//         isbaojie={showPoList}
//         setNum={(v) => {
//           setForNum(v);
//         }}
//       />
//     );
//   };
//   const InterestedCustomers = () => {// 兴趣客户转化
//     const InterestedCustomers = InterestedCustomersComponent.components.Form;
//     return (
//       <InterestedCustomers
//         params={creatParams}
//         timevalue={timevalue}
//         poList={poList}
//         setTimevalue={(v) => {
//           setTimevalue(v);
//         }}
//         setCreatParams={(v) => {
//           setCreatParams(v);
//         }}
//         checkType={checkType}
//         canChangeTime={canChangeTime}
//         isbaojie={showPoList}
//         setNum={(v) => {
//           setForNum(v);
//         }}
//       />
//     );
//   }

//   const PurchasedNotOpened = () => {// 已购未开卡
//     const PurchasedNotOpened = PurchasedNotOpenedComponent.components.Form;
//     return (
//       <PurchasedNotOpened
//         params={creatParams}
//         timevalue={timevalue}
//         poList={poList}
//         setTimevalue={(v) => {
//           setTimevalue(v);
//         }}
//         setCreatParams={(v) => {
//           setCreatParams(v);
//         }}
//         checkType={checkType}
//         canChangeTime={canChangeTime}
//         isbaojie={showPoList}
//         setNum={(v) => {
//           setForNum(v);
//         }}
//       />
//     );
//   }

//   const MembersDay = () => {// 会员日
//     const MembersDay = MembersDayComponent.components.Form;
//     return (
//       <MembersDay
//         params={creatParams}
//         timevalue={timevalue}
//         poList={poList}
//         setTimevalue={(v) => {
//           setTimevalue(v);
//         }}
//         setCreatParams={(v) => {
//           setCreatParams(v);
//         }}
//         checkType={checkType}
//         canChangeTime={canChangeTime}
//         isbaojie={showPoList}
//         setNum={(v) => {
//           setForNum(v);
//         }}
//       />
//     );
//   }

//   const HighValueUserPurchaseConversion = () => {// 高京享值用户加购转化
//     const HighValueUserPurchaseConversion = HighValueUserPurchaseConversionComponent.components.Form;
//     return (
//       <HighValueUserPurchaseConversion
//         params={creatParams}
//         timevalue={timevalue}
//         poList={poList}
//         setTimevalue={(v) => {
//           setTimevalue(v);
//         }}
//         setCreatParams={(v) => {
//           setCreatParams(v);
//         }}
//         checkType={checkType}
//         canChangeTime={canChangeTime}
//         isbaojie={showPoList}
//         setNum={(v) => {
//           setForNum(v);
//         }}
//       />
//     );
//   }

//   const PlusMember = () => { // 京东plus会员
//     const PlusMember = PlusMemberComponent.components.Form;
//     return (
//         <PlusMember
//           params={creatParams}
//           setCreatParams={(v) => {
//             setCreatParams(v);
//           }}
//           checkType={checkType}
//           setNum={(v) => {
//             setForNum(v);
//           }}
//         />
//       );
//   }

//   const ValueCard = () => { // 储值卡
//     const ValueCard = ValueCardComponent.components.Form;
//     return (
//         <ValueCard
//           params={creatParams}
//           setCreatParams={(v) => {
//             setCreatParams(v);
//           }}
//           checkType={checkType}
//           setNum={(v) => {
//             setForNum(v);
//           }}
//         />
//       );
//   }

//   const MemberPoint = () => { // 会员积分提醒
//     const Members = MemberPointComponent.components.Form;
//     return (
//         <Members
//           params={creatParams}
//           setCreatParams={(v) => {
//             setCreatParams(v);
//           }}
//           checkType={checkType}
//           setNum={(v) => {
//             setForNum(v);
//           }}
//         />
//       );
//   }

//   const LiveInteresting = () => { // 直播兴趣转换
//     const Lives = LiveInterestingComponent.components.Form;
//     return (
//         <Lives
//           params={creatParams}
//           setCreatParams={(v) => {
//             setCreatParams(v);
//           }}
//           checkType={checkType}
//           setNum={(v) => {
//             setForNum(v);
//           }}
//         />
//       );
//   }

//   /**
//    * 人群校验
//    */
//   const checkCrowdInfoContent = async (modelId) => {
//     if (Number(modelId) === 4) {
//       // 开卡未购人群校验
//       return Promise.all(
//         Object.keys(NewVipNotPhase.data())
//           .filter((key) => key in NewVipNotPhase.validators)
//           .map((key) => NewVipNotPhase.validators[key](creatParams, linkList))
//       );
//     } else if (Number(modelId) === 3) {
//       // 活跃用户人群校验
//       return Promise.all(
//         Object.keys(ActiveClient.data())
//           .filter((key) => key in ActiveClient.validators)
//           .map((key) => ActiveClient.validators[key](creatParams, linkList))
//       );
//     } else if (Number(modelId) === 5) {
//       // 首购人群校验
//       return Promise.all(
//         Object.keys(FirstPurchaseCrowd.data())
//           .filter((key) => key in FirstPurchaseCrowd.validators)
//           .map((key) =>
//             FirstPurchaseCrowd.validators[key](creatParams, linkList)
//           )
//       );
//     } else if (Number(modelId) === 7) {
//       // 热爱好物人群校验
//       return Promise.all(
//         Object.keys(LoveGoodsComponent.data())
//           .filter((key) => key in LoveGoodsComponent.validators)
//           .map((key) =>
//             LoveGoodsComponent.validators[key](creatParams, linkList)
//           )
//       );
//     } else if (Number(modelId) === 8) {
//       // 会员拉新人群校验
//       return Promise.all(
//         Object.keys(PullNewMemberComponent.data())
//           .filter((key) => key in PullNewMemberComponent.validators)
//           .map((key) =>
//             PullNewMemberComponent.validators[key](creatParams, linkList)
//           )
//       );
//     } else if (Number(modelId) === 9) {
//       // 会员生日礼校验
//       return Promise.all(
//         Object.keys(BirthayPresentComponent.data())
//           .filter((key) => key in BirthayPresentComponent.validators)
//           .map((key) =>
//             BirthayPresentComponent.validators[key](creatParams, linkList)
//           )
//       );
//     } else if (Number(modelId === 10)) {
//       // 周年礼
//       return Promise.all(
//         Object.keys(YearPresentComponent.data())
//           .filter((key) => key in YearPresentComponent.validators)
//           .map((key) =>
//             YearPresentComponent.validators[key](creatParams, linkList)
//           )
//       );
//     } else if (Number(modelId === 11)) {
//       // 沉睡用户唤醒
//       return Promise.all(
//         Object.keys(SleepAwakenComponent.data())
//           .filter((key) => key in SleepAwakenComponent.validators)
//           .map((key) =>
//             SleepAwakenComponent.validators[key](creatParams, linkList)
//           )
//       );
//     } else if (Number(modelId === 12)) {
//       // 百日礼
//       return Promise.all(
//         Object.keys(HundredthDayComponent.data())
//           .filter((key) => key in HundredthDayComponent.validators)
//           .map((key) =>
//             HundredthDayComponent.validators[key](creatParams, linkList)
//           )
//       );
//     }else if (Number(modelId === 14)) {
//       // 兴趣客户转化
//       return Promise.all(
//         Object.keys(InterestedCustomersComponent.data())
//           .filter((key) => key in InterestedCustomersComponent.validators)
//           .map((key) =>
//           InterestedCustomersComponent.validators[key](creatParams, linkList)
//           )
//       );
//     }else if (Number(modelId === 15)) {
//       // 已购未开卡人群
//       return Promise.all(
//         Object.keys(PurchasedNotOpenedComponent.data())
//           .filter((key) => key in PurchasedNotOpenedComponent.validators)
//           .map((key) =>
//           PurchasedNotOpenedComponent.validators[key](creatParams, linkList)
//           )
//       );
//     }else if (Number(modelId === 13)) {
//       // 会员日
//       return Promise.all(
//         Object.keys(MembersDayComponent.data())
//           .filter((key) => key in MembersDayComponent.validators)
//           .map((key) =>
//           MembersDayComponent.validators[key](creatParams, linkList)
//           )
//       );
//     } else if (Number(modelId === 16)) {
//       // 复购提醒
//       return Promise.all(
//         Object.keys(RepurchaseReminderComponent.data())
//           .filter((key) => key in RepurchaseReminderComponent.validators)
//           .map((key) =>
//             RepurchaseReminderComponent.validators[key](creatParams.viewButton.secondHalf.addParam, linkList)
//           )
//       );
//     } else if(Number(modelId === 17)) {
//       // 高京享值
//       return Promise.all(
//         Object.keys(HighValueUserPurchaseConversionComponent.data())
//           .filter((key) => key in HighValueUserPurchaseConversionComponent.validators)
//           .map((key) =>
//           HighValueUserPurchaseConversionComponent.validators[key](creatParams, linkList)
//           )
//       );
//     } else if(Number(modelId === 18)) {
//         // 储值卡
//         return Promise.all(
//           Object.keys(ValueCardComponent.data())
//             .filter((key) => key in ValueCardComponent.validators)
//             .map((key) =>
//                 ValueCardComponent.validators[key](creatParams.viewButton.secondHalf.addParam, linkList)
//             )
//         );
//     } else if(Number(modelId === 19)) {
//         // plus会员
//         return Promise.all(
//           Object.keys(PlusMemberComponent.data())
//             .filter((key) => key in PlusMemberComponent.validators)
//             .map((key) =>
//                 PlusMemberComponent.validators[key](creatParams.viewButton.secondHalf.addParam, linkList)
//             )
//         );
//     } else if(Number(modelId === 20)) {
//         return Promise.all(
//           Object.keys(LiveInterestingComponent.data())
//             .filter((key) => key in LiveInterestingComponent.validators)
//             .map((key) =>
//             LiveInterestingComponent.validators[key](creatParams, linkList)
//             )
//         );
//     } else if(Number(modelId === 21)) {
//         return Promise.all(
//           Object.keys(MemberPointComponent.data())
//             .filter((key) => key in MemberPointComponent.validators)
//             .map((key) =>
//             MemberPointComponent.validators[key](creatParams, linkList)
//             )
//         );
//     }
//   };
//   /**
//    * 展示短信模块
//    */
//   const showSmsInfo = () => {
//     const Content = SMSInfoForm.components.Form;
//     return (
//       <Content
//         params={creatParams}
//         createTime={props.location.state?.data?.createTime ?? 0}
//         poList={poList}
//         setTemplate={(v) => {
//           setTemplate(v);
//         }}
//         getPhoneList={() => {
//           getPhoneList();
//         }}
//         setEnough={(v) => {
//           setEnough(v);
//         }}
//         phoneList={phoneList}
//         setTestParams={(v) => {
//           setTestParams(v);
//         }}
//         testParams={testParams}
//         linkList={linkList}
//         setLink={(v) => {
//           setLinkList(v);
//         }}
//         checkType={checkType}
//         setInvitateInfo={(v) => {
//           setCreatParams(v);
//         }}
//         tempTplData={tempTplData}
//         forNum={forNum}
//         filterCondition={filterConditionCheckboxs}
//         setFilterCondition={(v) => {
//           setFilterConditionCheckboxs(v);
//         }}
//         filterMaxMemberCountReal={filterMaxMemberCountReal}
//       />
//     );
//   };

//   /**
//    * 校验短信模块是否全部填写
//    */
//   const checkSmsInfoContent = async () => {
//     return Promise.all(
//       Object.keys(SMSInfoForm.data())
//         .filter((key) => key in SMSInfoForm.validators)
//         .map((key) => SMSInfoForm.validators[key]({...creatParams, ...filterConditionCheckboxs}))
//     );
//   };
//   const checkBaseInfo = async () => {
//     const temp = { ...creatParams,
//       filterAlreadySend: creatParams.filterAlreadySend ?? 0,
//       filterOrderCount : creatParams.filterOrderCount ?? 0,
//       filterMaxMemberCount : creatParams.filterMaxMemberCount ? filterMaxMemberCountReal : 0,
//       filterMaxMemberCountShow : creatParams.filterMaxMemberCount ?? 0,
//       filterLastOrderTime : creatParams?.filterLastOrderTime ?? 0,
//       filterCrowdId : creatParams?.filterCrowdId ?? '',
//       filterCrowdName : creatParams?.filterCrowdName ?? '',
//     };
//     try {
//       temp.crowdCount = forNum;
//       temp.campaignModelId = creatParams.viewButton.modelId;
//       temp.frequencyValue = Number(creatParams.frequencyValue);
//       if (!temp.smsModelId) {
//         temp.smsModelId = -1;
//       }
//       // 此处要传的是前一页的模型名称
//       if (Number(checkType) === 1) {
//         // 创建时获取的model名
//         temp.campaignModel = props.location.state.data.activityName;
//       } else {
//         // 复制时获取的model名
//         temp.campaignModel = props.location.state.data.campaignModel;
//       }
//       // 判断选择短信模板后用户是否进行过修改（决定是否传模板id）
//       if (template.content !== temp.smsContent) {
//         temp.smsModelId = -1;
//       } else {
//         temp.smsModelId = template.id;
//       }

//       if (temp.smsContent.indexOf('3.cn') !== -1) {
//         temp.smsContent = temp.smsContent.replace(
//           `${linkList.short}`,
//           '#oldshortLink'
//         );
//         temp.smsLongUrl = linkList.long;
//         temp.smsShortUrl = linkList.short.replace(' ', '');
//       } else {
//         temp.smsLongUrl = '';
//         temp.smsShortUrl = '';
//       }
//       if (showPoList && creatParams.smsPoNum === '') {
//         LzMsg.error('请选择po号');
//         return;
//       }
//       if (
//         showPoList &&
//         !poList.find(
//           (item) => Number(item.value) === Number(creatParams.smsPoNum)
//         )
//       ) {
//         // 如果在poList中没有找到当前的po值
//         LzMsg.error('请选择正确的po号');
//         return;
//       }
//       if (!creatParams.campaignStartTime) {
//         LzMsg.error('请选择活动开始时间');
//         return;
//       }
//       if (!creatParams.campaignEndTime) {
//         LzMsg.error('请选择活动结束时间');
//         return;
//       }
//       if (!creatParams.lauchDelayTime) {
//         LzMsg.error('请选择短信投放时间点');
//         return;
//       }
//       if (
//         creatParams.campaignStartTime + creatParams.lauchDelayTime <
//         new Date().getTime()
//       ) {
//         LzMsg.error('请正确选择短信投放时间点');
//         return;
//       } else if (creatParams.crowdDelayTime + (10 * 60 * 1000) > Number(creatParams.lauchDelayTime)) {
//         LzMsg.error('短信投放时间点应大于人群运算时间点至少10分钟');
//         return false;
//       }
//       await checkBaseInfoContent();
//       await checkCrowdInfoContent(creatParams.viewButton.modelId);
//       await checkSmsInfoContent();
//       if (creatParams.smsContent.indexOf('3.cn') !== -1 && !linkList.long) {
//         LzMsg.error(
//           '请填入由系统自带短链接工具生成的短链，内容中其他渠道生成的短链接会造成发送失败。'
//         );
//       } else if (creatParams.smsContent.indexOf('#oldshortLink') !== -1) {
//         LzMsg.error('错误的短信内容：#oldshortLink');
//       } else if (
//         creatParams.smsContent.indexOf('3.cn') !== -1 &&
//         creatParams.smsContent.indexOf(` ${linkList.short} `) === -1
//       ) {
//         LzMsg.error('短链接前后请添加空格！');
//       } else if (!isEnough) {
//         LzMsg.error('账户余额不足，请确认余额充足后创建任务');
//       } else {
//         setPageLoading(true);
//         // 如果有传来的结束时间且未变更过的话 变成当天的23：59：59
//         if (Number(tempEndTime) !== Number(temp.campaignEndTime)) {
//           temp.campaignEndTime += 86399000;
//           setTimeChange(true);
//         }
//         temp.smsContent = `${temp.smsContent} ${CONSTANTS.LZ_SMS_CANCEL_WORD}`;
//         PrivateService.checkSmsContent({
//           content: creatParams.smsContent.replace(` ${linkList.short} `, ''),
//           ifSpecialWordCheck: true,
//         })
//           .then((res) => {
//             // 只给宝洁弹窗
//             if (utils.isPGShop()) {
//               setPageLoading(false);
//               setSecondData(temp);
//               setSecondCheckDialog(true);
//               return;
//             }
//             PrivateService.setAutoNewCompaign(temp)
//               .then((res) => {
//                 setPageLoading(false);
//                 history.push('/smsautomarket/marketing', {
//                   from: 'resultData',
//                 });
//                 LzMsg.success('活动创建成功');
//               })
//               .catch(() => {
//                 // 如果后端出现问题，把占位符再替回短链
//                 if (
//                   temp.smsContent.indexOf('#oldshortLink') !== -1 &&
//                   linkList.long
//                 ) {
//                   temp.smsContent = temp.smsContent.replace(
//                     '#oldshortLink',
//                     `${linkList.short}`
//                   );
//                 }
//                 temp.smsContent = temp.smsContent.replace(` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`, '');
//                 // 把结束时间变回去
//                 if (timeChange) {
//                   setTimeChange(false);
//                 }
//                 setPageLoading(false);
//                 setCreatParams(temp);
//               });
//           })
//           .catch(() => {
//             if (
//               temp.smsContent.indexOf('#oldshortLink') !== -1 &&
//               linkList.long
//             ) {
//               temp.smsContent = temp.smsContent.replace(
//                 '#oldshortLink',
//                 `${linkList.short}`
//               );
//             }
//             temp.smsContent = temp.smsContent.replace(` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`, '');
//             if (timeChange) {
//               setTimeChange(false);
//             }
//             setPageLoading(false);
//             setCreatParams(temp);
//           });
//       }
//       // 走接口
//     } catch (e) {
//       LzMsg.error(e.message);
//       setPageLoading(false);
//     }
//   };
//   // 二次确认发送
//   const secondCheckSubmit = (temp) => {
//     PrivateService.setAutoNewCompaign(temp)
//       .then((res) => {
//         setPageLoading(false);
//         setSecondCheckDialog(false);
//         history.push('/smsautomarket/marketing', {
//           from: 'resultData',
//         });
//         LzMsg.success('活动创建成功');
//       })
//       .catch(() => {
//         // 如果后端出现问题，把占位符再替回短链
//         if (temp.smsContent.indexOf('#oldshortLink') !== -1 && linkList.long) {
//           temp.smsContent = temp.smsContent.replace(
//             '#oldshortLink',
//             `${linkList.short}`
//           );
//         }
//         temp.smsContent = temp.smsContent.replace(` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`, '');
//         // 把结束时间变回去
//         if (timeChange) {
//           setTimeChange(false);
//         }
//         setPageLoading(false);
//         setCreatParams(temp);
//       });
//   };
//   useEffect(() => {
//     // 拿短信签名
//     DingzhiService.getSmssign()
//       .then((res: any) => {
//         // 获取品牌列表
//         DingzhiService.getBrands().then((resbrand) => {
//           // setIsBaojie(resbrand.data.needMenu)
//           // setBrand(resbrand.data.shopList)
//           setCheckType(props.location.state.checkType);
//           let tempObj = { ...creatParams };

//           const tempTest = { ...testParams };
//           // 拿到预留测试手机号
//           DingzhiService.getSignphone()
//             .then((resTest: any) => {
//               setphoneList(resTest.data);
//               // 如果有测试手机号 则赋值首个到测试参数对象
//               if (resTest.data.length > 0) {
//                   tempTest.receivePhone = [resTest.data[0]?.phone];
//               }
//               // if (resTest.data.split(',')[0]) {
//               //   tempTest.receivePhone = resTest.data.split(',')[0];
//               // }
//               // 复制或查看要走接口拿数据
//               if (
//                 props.location.state &&
//                 props.location.state.checkType !== 1
//               ) {
//                 PrivateService.checkAutoNewCompaign({
//                   id: props.location.state.data.id,
//                 })
//                   .then((resp: any) => {
//                     // 数据格式完全按请求回的数据来
//                     tempObj = resp.data;
//                     tempObj.smsContent = Number(props.location.state.checkType) === 3 && +props.location.state.data.createTime < CONSTANTS.UP_TIME ? tempObj.smsContent : tempObj.smsContent.replace(' 回T退', '');
//                     // 在此基础上赋值上签名
//                     tempObj.smsSign = res.data;
//                     tempObj.filterAlreadySend = tempObj.filterAlreadySend ? tempObj.filterAlreadySend : null;
//                     tempObj.filterOrderCount = tempObj.filterOrderCount ? tempObj.filterOrderCount : null;
//                     tempObj.filterMaxMemberCount = tempObj.filterMaxMemberCountShow ? tempObj.filterMaxMemberCountShow : null;
//                     tempObj.filterLastOrderTime = tempObj?.filterLastOrderTime ? tempObj?.filterLastOrderTime : null;
//                     tempObj.filterCrowdId = tempObj?.filterCrowdId ? tempObj?.filterCrowdId : null;
//                     tempObj.filterCrowdName = tempObj?.filterCrowdName ? tempObj?.filterCrowdName : null;
//                     setFilterConditionCheckboxs(
//                       {
//                         ...filterConditionCheckboxs,
//                         filterAlreadySendTip: tempObj.filterAlreadySend ? true : false,
//                         filterOrderCountTip: tempObj.filterOrderCount ? true : false,
//                         filterMaxMemberCountTip: tempObj.filterMaxMemberCount ? true : false,
//                         filterLastOrderTimeTip: tempObj?.filterLastOrderTime ? true : false,
//                         filterCrowdTip: tempObj?.filterCrowdId ? true : false,
//                       }
//                     )
//                     // 如果是查看的话，把预估人数反显 props.location.state.checkType === 3
//                     if(Number(props.location.state.checkType) === 3) {
//                       setForNum(resp.data.crowdCount);
//                     }
//                     // 赋值时间
//                     if (
//                       resp.data.campaignStartTime ||
//                       resp.data.campaignEndTime
//                     ) {
//                       //  任务时间
//                       const timevalue = [
//                         moment(resp.data.campaignStartTime),
//                         moment(resp.data.campaignEndTime),
//                       ];
//                       setTempEndTime(resp.data.campaignEndTime);
//                       setTimevalue(timevalue);
//                     }
//                     // 如果是查看，且有短链的话，把短信内容的#oldshortLink换成正常短链
//                     if (tempObj.smsShortUrl) {
//                       tempObj.smsContent = tempObj.smsContent.replace(
//                         '#oldshortLink',
//                         `${tempObj.smsShortUrl}`
//                       );
//                     }
//                     // 查看或赋值 反显时把` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`也去掉
//                     tempObj.smsContent = tempObj.smsContent.replace(
//                         ` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`,
//                       ''
//                     );
//                     // 如果是复制，名字加副本
//                     if (Number(props.location.state.checkType) === 2) {
//                       tempObj.campaignName = `${props.location.state.data.campaignName}副本`;
//                       // 如果是复制且又短链，赋值linklist以通过校验
//                       if (tempObj.smsShortUrl) {
//                         setLinkList({
//                           long: tempObj.smsLongUrl,
//                           short: tempObj.smsShortUrl,
//                         });
//                       }
//                     }
//                     tempTest.fullContent = tempObj.smsContent;

//                     setTestParams({
//                       ...tempTest,
//                       fullContent: `${tempObj.smsContent} ${CONSTANTS.LZ_SMS_CANCEL_WORD}`,
//                     });
//                     setCreatParams(tempObj);
//                     // 因为短信文案给组件赋值，有一个延迟，所以这里也同步做延迟取消loading，让用户不会在loading消失之后还看不到文案更新
//                     setTimeout(() => {
//                       setPageLoading(false);
//                     }, 3000)
//                   })
//                   .catch(() => {
//                     setPageLoading(false);
//                   });
//                 // 如果是新建，路由传参只传viewbutton，其他走默认值
//               } else if (
//                 props.location.state &&
//                 props.location.state.checkType === 1
//               ) {
//                 tempObj.smsSign = res.data;
//                 tempObj.campaignRemark = `${moment().format(
//                   'M'
//                 )}月${moment().format('D')}日创建活动`;
//                 tempObj.viewButton = props.location.state.data.viewButton;
//                 // 如果是宝洁 加上默认店名
//                 // if (resbrand.data.needMenu) {
//                 //   tempObj.viewButton.secondHalf.subShopId = 0
//                 //   tempObj.viewButton.secondHalf.subShopName = "宝洁官方旗舰店"
//                 // }
//                 setCreatParams(tempObj);
//                 setPageLoading(false);
//                 setTestParams(tempTest);
//               }
//             })
//             .catch((e) => {
//               console.log(e);
//             });
//         });
//       })
//       .catch((e) => {
//         console.log(e);
//       });
//   }, []);
//   useEffect(() => {
//     const num = utils.calcSmsNumber(creatParams.smsContent, creatParams.smsSign);
//     const real = Math.floor(creatParams.filterMaxMemberCount / num);
//     setEnough(JSON.parse(localStorage.getItem('LZ_SMS_BALANCE')).smsBalance >= creatParams.filterMaxMemberCount);
//     setFilterMaxMemberCountReal(real ? real : 0);
//   }, [creatParams.smsContent, creatParams.smsSign, creatParams.filterMaxMemberCount])
//   // 发送测试短信参数
//   const [testParams, setTestParams] = useState({
//     fullContent: '',
//     receivePhone: [],
//     smsTestType: 3, // 催付1 群发2 此处3
//   });
//   const [phoneList, setphoneList] = useState([]);

//   // 参数的结束时间是否变为当天的23：59：59
//   const [timeChange, setTimeChange] = useState(false);

//   // 是否余额足够
//   const [isEnough, setEnough] = useState(true);

//   // 暂存模板内容，来判断用户选了模板后是否进行了更改，决定是否变模板id为-1
//   const [template, setTemplate] = useState({
//     content: '',
//     id: '',
//   });
//   return (
//     <div>
//       <div className={styles.pageContent}>{showBaseInfo()}</div>
//       <div style={{ marginBottom: '10px' }}>
//         {
//           Number(props.location.state.data.viewButton.modelId) === 12
//           ? HundredthDay() // 百日礼
//           : Number(props.location.state.data.viewButton.modelId) === 11
//           ? SleepAwaken() // 沉睡用户唤醒
//           : Number(props.location.state.data.viewButton.modelId) === 10
//           ? YearPresent() // 周年礼
//           : Number(props.location.state.data.viewButton.modelId) === 9
//           ? BirthayPresent() // 满月礼
//           : Number(props.location.state.data.viewButton.modelId) === 8
//           ? PullNewMember() // 会员拉新
//           : Number(props.location.state.data.viewButton.modelId) === 7
//           ? LoveGoods() // 热爱好物
//           : Number(props.location.state.data.viewButton.modelId) === 5
//           ? firstPurchaseCrowd() // 首购人群
//           : Number(props.location.state.data.viewButton.modelId) === 4
//           ? showCrowdInfo() // 新会员开卡未购
//           : Number(props.location.state.data.viewButton.modelId) === 3
//           ? activeCrowd() // 活跃用户人群
//           : Number(props.location.state.data.viewButton.modelId) === 13
//           ? MembersDay() //会员日
//           : Number(props.location.state.data.viewButton.modelId) === 14
//           ? InterestedCustomers() // 兴趣客户转化
//           : Number(props.location.state.data.viewButton.modelId) === 15
//           ? PurchasedNotOpened() // 已购未开卡
//           :Number(props.location.state.data.viewButton.modelId) === 16
//           ? RepurchaseReminder() // 复购提醒
//           :Number(props.location.state.data.viewButton.modelId) === 17//前端自己编的id
//           ? HighValueUserPurchaseConversion() // 高京享值用户加购转化
//           :Number(props.location.state.data.viewButton.modelId) === 18
//           ? ValueCard() // 储值卡
//           :Number(props.location.state.data.viewButton.modelId) === 19
//           ? PlusMember() // 京东plus会员
//           :Number(props.location.state.data.viewButton.modelId) === 20
//           ? LiveInteresting() // 直播兴趣转化
//           :Number(props.location.state.data.viewButton.modelId) === 21
//           ? MemberPoint() // 会员积分提醒
//           :''
//         }
//       </div>
//       <div style={{ marginBottom: '10px' }}>{showSmsInfo()}</div>
//       <div className={styles.finishContent}>
//         {Number(checkType) === 3 ? (
//           <div>
//             <Button
//               type="normal"
//               className={styles.finishButton}
//               onClick={() => {
//                 history.push('/smsautomarket/marketing', {
//                   from: 'resultData',
//                   params: props.location.state.params
//                 });
//               }}
//             >
//               返回
//             </Button>
//           </div>
//         ) : (
//           <div style={{ background: '#fff' }}>
//             <Button
//               type="primary"
//               className={styles.finishButton}
//               onClick={() => checkBaseInfo()}
//             >
//               确认创建
//             </Button>
//             <Button
//               type="normal"
//               className={styles.finishButton}
//               style={{ marginRight: '20px' }}
//               onClick={() => {
//                 history.push('/smsautomarket/marketing', {
//                   from: 'cancle',
//                   checkType,
//                 });
//               }}
//             >
//               取消
//             </Button>
//           </div>
//         )}
//       </div>
//       <Loading visible={pageLoading} fullScreen shape="fusion-reactor" />
//       {/* 短信二次确认弹窗 */}
//       <LzDialog
//         shouldUpdatePosition
//         style={{ width: 650 }}
//         visible={secondCheckDialog}
//         footer={false}
//         title="二次确认弹窗"
//         onCancel={() => setSecondCheckDialog(false)}
//         onClose={() => setSecondCheckDialog(false)}
//       >
//         <SecondCheckDialog
//           initData={secondData}
//           poList={poList}
//           submit={() => {
//             secondCheckSubmit(secondData);
//           }}
//           cancel={() => setSecondCheckDialog(false)}
//         />
//       </LzDialog>
//     </div>
//   );
// };

// export default NewMisionCreate;

export default function NewMisionCreate(props) {
  return <div></div>
}
